<div class="row tabs">
  <ng-container *ngFor="let tab of tabs">
    <div
      *ngIf="tab.show === true || (tab.show | async)"
      class="col-auto tab"
      [id]="'tabs-' + tab.id"
      [class.active]="tab.id === activeTab"
      (click)="changeTab(tab.id)"
    >
      {{ tab.text }}
    </div>
  </ng-container>
</div>
